<template>
  <discovery-splash 
    @search="search" 
    :countries="countries" 
    :selectedCountry="selectedCountry" />
  <div class="container-fluid mb-5">
    <template v-for="(cat, i) in discovery" v-bind:key="i">
      <template v-if="cat.layout === 'multi'">
        <h2 class="tittle">{{ cat.name }}</h2>
        <button-pills-container
          :cat="cat"
          :selectedChild="selectedChild"
          @selectChild="selectChild"
        />
        <vertical-carousel-app
          v-bind:key="selectedChild"
          :category="cat.childs[selectedChild]"
          :offtitle="true"
        />
      </template>
      <vertical-carousel-app v-else :category="cat" />
    </template>
  </div>


  <featured-actors :content="actor" />

  <live-on-channels />

  <DiscoverByMood class="my-5"/>

  <!-- <vertical-carousel
    v-if="upcoming.length > 0"
    :title="$t('discover.upcoming')"
    :assets="upcoming"
    :hidrated="true"
  /> -->
  
  <our-products-mobile v-if="isMobile()" />
  <our-products v-else />

  <f-a-q-components></f-a-q-components>
  <be-part-of> </be-part-of>

<!-- 
  <div v-if="searchActive" class="container mt-5"></div>
  <div v-else class="container mt-5">
    <template v-for="(item, i) in categories">
      <template v-if="i === 3">
        <featured-actors :content="actor" :limit_movies="true" />
      </template>
      <template v-if="i === 6"><DiscoverByMood /></template>
      <template v-if="i === 9">
        <our-products-mobile v-if="isMobile()" />
        <our-products v-else />
      </template>

      <horizontal-carousel
        v-if="item.layout === 'horizontal'"
        :title="item.name"
        :assets="item.assets"
        :show_navigation="false"
      />
      <vertical-carousel
        v-else-if="item.layout === 'vertical'"
        :title="item.name"
        :assets="item.assets"
        :type="item.class"
        :show_navigation="item.class !== 'top'"
      />
      <tabbed-vertical-carousel
        v-else-if="item.layout === 'tabbed-vertical'"
        :title="item.name"
        :assets="item.tabs"
        :type="item.class"
      />
      <hr v-if="item.layout !== 'horizontal'" class="line-jump" />
    </template>
    <f-a-q-components></f-a-q-components>
    <be-part-of> </be-part-of>
  </div> -->
</template>

<script>
import DiscoverySplash from "../../components/discovery/DiscoverySplash.vue";
import HorizontalCarousel from "@/components/movies/HorizontalCarousel.vue";
import VerticalCarousel from "@/components/movies/VerticalCarousel.vue";
import TabbedVerticalCarousel from "@/components/movies/TabbedVerticalCarousel.vue";
import { OrizonApiClient } from "@/services/OrizonApiClient";
import FAQComponents from "@/components/generic/FAQComponents.vue";
import BePartOf from "@/components/landing/BePartOf.vue";
import FeaturedActors from "@/components/landing/FeaturedActors.vue";
import OurProducts from "@/components/landing/OurProducts.vue";
import DiscoverByMood from "@/components/discovery/DiscoverByMood.vue";
import OurProductsMobile from "@/components/landing/OurProductsMobile.vue";
import ButtonPillsContainer from "@/components/generic/ButtonPillsContainer.vue";
import VerticalCarouselApp from "@/components/app/partials/VerticalCarouselApp.vue";

import { i18n } from "@/functional/languages";

import MetaService from "@/services/MetaService";
import { mapState } from "pinia";
import { ActorStore } from "@/stores/actorStore";
import { FlixlatinoApiClient } from "@/services/FlixlatinoApiClient";
import LiveOnChannels from "@/components/app/partials/page/LiveOnChannels.vue";
import { CategoriesStore } from "@/stores/categoriesStore";
const flixApiClient = new FlixlatinoApiClient();
const apiClient = new OrizonApiClient();
// noinspection JSCheckFunctionSignatures
export default {
  name: "DiscoverView",
  metaInfo: () => {
    return {
      title: i18n.global.t("discover.meta.title"),
      htmlAttrs: { lang: i18n.global.locale },
      meta: [
        MetaService.robotIndex(),
        MetaService.description(i18n.global.t("discover.meta.description")),
      ],
    };
  },
  props: {
    country: {
      type: String,
      required: false,
    }
  },
  components: {
    ButtonPillsContainer,
    VerticalCarouselApp,
    LiveOnChannels,
    OurProductsMobile,
    DiscoverByMood,
    OurProducts,
    FeaturedActors,
    BePartOf,
    FAQComponents,
    TabbedVerticalCarousel,
    HorizontalCarousel,
    DiscoverySplash,
    VerticalCarousel,
  },
  methods: {
    search(query) {
      this.searchActive = query.length > 0;
    },
    selectChild(index) {
      this.selectedChild = index;
    },
    loadAll() {
      this.$bus.emit("contentLoading", true);
      Promise.all([
        this.loadCountries(),
        this.loadActor(),
        this.loadUpcoming(),
        this.loadDiscover(),
        this.loadLiveChannels(),
      ]).finally(()=>{
        this.$bus.emit("contentLoading", false);
      })
    },
    countrySelected(country){
      if(country){
        let index = this.initial_countries.indexOf(country);
        let countries = [...this.initial_countries];
        countries.splice(index, 1);
        this.countries = [country, ...countries]
      }else{
        this.countries = this.initial_countries;
      }
      this.selectedCountry = country;
      this.searchCountry(country?.id);
    },
    searchCountry(countryId){
      this.$bus.emit("contentLoading", true);
      this.loadDiscover(countryId).then(()=>{
        this.$bus.emit("contentLoading", false);
      });
    },
    loadActor() {
      return apiClient.get("/landing").then((response) => {
        if (
          response !== null &&
          response.data !== null &&
          !response.data.error
        ) {
          this.actor = response.data.actor;
          this.setFeaturedActor(response.data.actor);
        }
      });
    },
    loadUpcoming() {
      return flixApiClient
        .get("upcoming/list")
        .then((response) => response.data)
        .then((data) => {
          this.upcoming = data.upcoming;
        });
    },
    loadDiscover(country) {
      if(country){
        return flixApiClient
          .getCountryCategories(country)
          .then((data) => {
            this.discovery = data.categories;
            this.updateMetasCountry();
          });
      }else{
        return flixApiClient
          .get("discovery/list")
          .then((response) => response.data)
          .then((data) => {
            this.discovery = data.discovery;
            this.updateMetas();
          });
      }
    },
    updateMetas() {
      this.$meta.canonicalUrls(
        this.$t("routes.discover", "es"),
        this.$t("routes.discover", "en")
      );
      MetaService.updateTitle(
        i18n.global.t("discover.meta.title")
      );
      MetaService.updateDescription(
        i18n.global.t("discover.meta.description")
      )
    },
    updateMetasCountry() {
      this.$meta.canonicalUrls(
        this.$t("routes.discover_country", 'es', {country:this.selectedCountry.locale.es.country_slug}),
        this.$t("routes.discover_country", 'en', {country:this.selectedCountry.locale.en.country_slug})
      );
      MetaService.updateTitle(
        i18n.global.t("discover.country.meta.title", {
          country: this.selectedCountry.name,
        })
      );
      MetaService.updateDescription(
        i18n.global.t("discover.country.meta.description", {
          country: this.selectedCountry.name,
        })
      );
      MetaService.clearDefaultCanonical();
      MetaService.updateCanonical(this.$route["path"], {
        en:  this.$t("routes.discover_country", 'en', {country:this.selectedCountry.locale.en.country_slug}),
        es: this.$t("routes.discover_country", 'es', {country:this.selectedCountry.locale.es.country_slug}),
      });
    },
    loadCountries() {
      return flixApiClient
        .get("countries/list")
        .then((response) => response.data)
        .then((data) => {
          // Temporary fix
          const priorizedCountries = ["mexico", "spain", "espana", "argentina", "colombia", "turkey", "turquia", "republica-dominicana", "dominican-republic"];

          const firstCountries = priorizedCountries
            .map(p => data.countries.find(c => c.slug.toLowerCase() === p))
            .filter(Boolean);

          const other = data.countries.filter(c =>
            !priorizedCountries.includes(c.slug.toLowerCase())
          );
          
          this.countries = [...firstCountries, ...other];
          this.initial_countries = [...firstCountries, ...other];

          if(this.country){
            let initialCountry = this.getCountryBySlug(this.country);
            if(initialCountry){
              this.countrySelected(initialCountry);
            }
          }
          
        });
    },
    getCountryBySlug(slug){
      let country = this.countries.filter(element => element.slug === slug);
      return country.length > 0 ? country[0] : null;
    },
    loadLiveChannels() {
      return flixApiClient.getLiveChannels().then((response) => {
        CategoriesStore().setLive(response.live);
      });
    }
  },
  computed: {
    ...mapState(ActorStore, ["setFeaturedActor"]),
    actor() {
      return ActorStore().featuredActor;
    },
  },
  beforeMount() {
    if (Object.keys(ActorStore().featuredActor).length === 0) {
      apiClient.get("/landing").then((response) => {
        if (
          response !== null &&
          response.data !== null &&
          !response.data.error
        ) {
          this.setFeaturedActor(response.data.actor);
        }
      });
    }
  },
  mounted() {
    flixApiClient.getLoggedOutInitData().then(() => {
      this.loadAll();
    });
      
    this.$bus.on("langChanged", () => {
      try {
        this.loadAll();
      } catch (e) {
        console.info("fetch landing", e.title);
      }
    });
    this.$meta.canonicalUrls(
      this.$t("routes.discover", "es"),
      this.$t("routes.discover", "en")
    );
  },
  created() {
    this.loadAll();
  },
  watch:{
    country(value){
      if(!value){
        this.countrySelected(null);
        return;
      }
      let country = this.getCountryBySlug(value);
      if(country){
        this.countrySelected(country);
      }
    }
  },
  data() {
    return {
      countries: [],
      initial_countries: [],
      category_list: [],
      discovery: [],
      upcoming: [],
      actor: null,
      selectedChild: 0,
      selectedCountry: null,
    };
  },
};
</script>

<style scoped lang="scss">
.line-jump {
  margin-bottom: 5em;
  display: block;
}
.tittle {
  font-weight: 400;
  margin: 1.5em 0 1.5em 0.5em;
}
.pills {
  margin: 0em 0 3em 0.7em;
}
</style>
